import {Controller} from "@hotwired/stimulus";
import $ from 'jquery';
import {Modal} from "bootstrap";

/* stimulusFetch: 'lazy' */
export default class extends Controller {

    static values = {
        litigantId: Number,
        note: String,
    };

    static targets = [
        'input',
        'button',
        'invalidReason',
    ];

    connect() {
        if (this.noteValue) {
            this.inputTarget.value = this.noteValue;
        }

        this.disableSubmitButton();
    }

    onInputChange() {
        this.isNoteValid();
    }

    saveNote() {
        if (this.inputTarget.value.length <= 1000) {
            $.ajax({
                url: routes['app_litigant_changelawyernoteforlitigant'],
                method: 'POST',
                data: {
                    litigantId: this.litigantIdValue,
                    note: this.inputTarget.value,
                },
                success: result => {
                    if (result.status) {
                        addAlert('success', result.message || 'Success message!');
                        this.disableSubmitButton();

                        if (this.noteValue.length === 0) {
                            dataLayer.push({
                                "event": "dataLayer.gaEvent",
                                "gaEvent": {
                                    "category": "message",
                                    "action": "messages_clientnote_create",
                                    "label": "",
                                },
                            });
                        } else {
                            dataLayer.push({
                                "event": "dataLayer.gaEvent",
                                "gaEvent": {
                                    "category": "message",
                                    "action": "messages_clientnote_update",
                                    "label": "",
                                },
                            });
                        }

                        this.noteValue = result.value;
                    }
                },
                error: () => {
                    addAlert('danger', translations['profile.An unknown error occurred.']);
                },
            })
        }
    }

    disableSubmitButton() {
        this.buttonTarget.disabled = true;
        this.buttonTarget.classList.add('btn-secondary');
        this.buttonTarget.classList.remove('btn-primary');
    }

    enableSubmitButton() {
        this.buttonTarget.disabled = false;
        this.buttonTarget.classList.add('btn-primary');
        this.buttonTarget.classList.remove('btn-secondary');
    }

    isNoteValid() {
        if (this.inputTarget.value.length <= 1000) {
            this.inputTarget.classList.remove('is-invalid');
            this.inputTarget.classList.remove('text-danger');
            this.invalidReasonTarget.style.setProperty('display', 'none');
            this.enableSubmitButton()
        } else {
            this.inputTarget.classList.add('is-invalid');
            this.inputTarget.classList.add('text-danger');
            this.invalidReasonTarget.style.removeProperty('display');
            this.disableSubmitButton()
        }
    }
}
